import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';
import { querySelector } from '../../../../utils';
import queryMetaHandler from '../../../../utils/queryMetaHandler';
import omitProps from '../../../../utils/omitProps';

const TableEquipment = gql`
  fragment TableEquipment on Equipment {
    id
    equipment_number
    equipment_type
    district {
      id
      name
    }
    department {
      id
      name
    }
    enabled
    notes
  }
`;

const GetAllEquipmentQuery = gql`
  query GetAllEquipment {
    all_equipment {
      edges {
        node {
          ...TableEquipment
        }
      }
    }
  }
  ${TableEquipment}
`;

const marshallData = ({ data, ownProps }) => {
  const equipmentList = querySelector(data, '$.all_equipment.edges[*].node', []);
  return {
    ...ownProps,
    data,
    equipmentList,
  };
};

const queryEquipmentData = graphql(GetAllEquipmentQuery, {
  props: marshallData,
});

export const queryEquipmentGQL = compose(
  queryEquipmentData,
  queryMetaHandler,
  omitProps(['data']),
);

const CreateEquipmentMutation = gql`
  mutation CreateEquipment($input : EquipmentCreateInput!) {
    equipment_create(input: $input) {
      ...TableEquipment
    }
  }
  ${TableEquipment}
`;

export const createEquipmentMutationGQL = (client, equipment) => {
  const variables = {
    input: {
      ...equipment,
    },
  };

  const options = {
    mutation: CreateEquipmentMutation,
    variables,
    refetchQueries: [
      { query: GetAllEquipmentQuery },
    ],
  };
  return client.mutate(options);
};

const UpdateEquipmentMutation = gql`
 mutation UpdateEquipmentEntry($input : EquipmentUpdateInput!) {
    equipment_update(input: $input) {
      ...TableEquipment
    }
  }
  ${TableEquipment}
`;

export const updateEquipmentMutationGQL = (client, equipment) => {
  const variables = {
    input: {
      ...equipment,
    },
  };

  const options = {
    mutation: UpdateEquipmentMutation,
    variables,
    refetchQueries: [
      { query: GetAllEquipmentQuery },
    ],
  };

  return client.mutate(options);
};

const ArchiveEquipmentMutation = gql`
  mutation ArchiveEquipment($input: EquipmentArchiveInput!) {
    equipment_archive(input: $input) 
  }
`;

export const archiveEquipmentMutationGQL = (client, equipmentId) => {
  const variables = {
    input: {
      id: equipmentId,
    },
  };

  const options = {
    mutation: ArchiveEquipmentMutation,
    variables,
    refetchQueries: [
      { query: GetAllEquipmentQuery },
    ],
  };

  return client.mutate(options);
};
